/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_1Inputs */

const en_loading_1 = /** @type {(inputs: Loading_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading…`)
};

const es_loading_1 = /** @type {(inputs: Loading_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando…`)
};

const fr_loading_1 = /** @type {(inputs: Loading_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement…`)
};

const de_loading_1 = /** @type {(inputs: Loading_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laden…`)
};

const ja_loading_1 = /** @type {(inputs: Loading_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込み中…`)
};

const zh_loading_1 = /** @type {(inputs: Loading_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载中…`)
};

const ar_loading_1 = /** @type {(inputs: Loading_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاري التحميل...`)
};

const id_loading_1 = /** @type {(inputs: Loading_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat...`)
};

const it_loading_1 = /** @type {(inputs: Loading_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento…`)
};

const ru_loading_1 = /** @type {(inputs: Loading_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка…`)
};

const pt_loading_1 = /** @type {(inputs: Loading_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando…`)
};

const ko_loading_1 = /** @type {(inputs: Loading_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로딩 중…`)
};

/**
* | output |
* | --- |
* | "Loading…" |
*
* @param {Loading_1Inputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const loading_1 = /** @type {((inputs?: Loading_1Inputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_1Inputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_loading_1(inputs)
	if (locale === "es") return es_loading_1(inputs)
	if (locale === "fr") return fr_loading_1(inputs)
	if (locale === "de") return de_loading_1(inputs)
	if (locale === "ja") return ja_loading_1(inputs)
	if (locale === "zh") return zh_loading_1(inputs)
	if (locale === "ar") return ar_loading_1(inputs)
	if (locale === "id") return id_loading_1(inputs)
	if (locale === "it") return it_loading_1(inputs)
	if (locale === "ru") return ru_loading_1(inputs)
	if (locale === "pt") return pt_loading_1(inputs)
	return ko_loading_1(inputs)
});